module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-slide",
    class: [_vm.isActive ? 'is-active' : '', _vm.isLeft ? 'is-left' : '', _vm.isRight ? 'is-right' : '']
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e4d3d14"}!./src/scripts/components/app-home-slide/template.html
// module id = 464
// module chunks = 0